import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" id=\"icon-plus\">\r\n<g>\r\n\t<polygon points=\"14.997,6.499 9,6.499 9,0.493 6.001,0.493 6.001,6.499 0.003,6.499 0.003,9.502 6.001,9.502\r\n\t\t6.001,15.508 9,15.508 9,9.502 14.997,9.502 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/plus.svg
// module id = ./app/general/svg/plus.svg
// module chunks = app